export default {"src":"/_next/static/media/wave.fdc1545f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};